export enum perksAlertsEnum {
  isNewMember = 'perksWelcomeNoBirthday',
  isOldMember = 'perksWelcomeBack',
  isAlreadyMember = 'perksAlreadyMember',
  isNewMemberWithBirthday = 'perksWelcomeWithBirthday',
  isOldMemberWithBirthday = 'perksWelcomeBackWithBirthday',
  isOldMemberWithBirthdayAlreadySaved = 'perksWelcomeBackWithBirthdayAlreadySaved',
  birthdayAdded = 'perksBirthdayAdded',
  birthdayAlreadySaved = 'perksBirthdayAlreadyAdded',
  perksReInstated = 'perksReInstated',
}

export const PERKS_DISCOUNT_TITLE = 'Perks price';
export const PREFERENCE_SAVE_ERROR_MESSAGE = 'There was a problem saving your preference. Please try again.';

export const PERKS_COUPON_SIGNUP_MESSAGING = 'Join JB Perks to get a $10 Welcome coupon & loads of member benefits!';
